// extracted by mini-css-extract-plugin
export default {"root":"page-inner_root_GTd7y"};